import { useEffect, useMemo, useState } from "react";
import { isCapacitorPlatform } from "./helpers";
import safeAreaInsets from "safe-area-insets";
import { Capacitor } from "@capacitor/core";

interface Insets {
	top: number;
	right: number;
	bottom: number;
	left: number;
}

export interface SafeAreaValues extends Insets {
	padding: string;
}

const defaultInsets: Insets = { top: 0, right: 0, bottom: 0, left: 0 };

/**
 * if capacitor true attaches onChange listener
 * @returns object with individual inset values (numbers) and a padding string
 */
export default function useSafeAreaListener(): SafeAreaValues {
	const [insets, setInsets] = useState<Insets>(defaultInsets);

	useEffect(() => {
		if (!isCapacitorPlatform() || Capacitor.getPlatform() !== "ios") {
			return;
		}

		const update = () => {
			setInsets({
				top: safeAreaInsets.top,
				right: safeAreaInsets.right,
				bottom: safeAreaInsets.bottom,
				left: safeAreaInsets.left,
			});
		};

		update();
		safeAreaInsets.onChange(update);

		return () => {
			safeAreaInsets.offChange(update);
			setInsets(defaultInsets);
		};
	}, []);

	return useMemo<SafeAreaValues>(
		() => ({
			...insets,
			padding: `${insets.top}px ${insets.right}px ${insets.bottom}px ${insets.left}px`,
		}),
		[insets]
	);
}
